import { PageHeader } from "components/Header/PageHeader"

export function PsyPageHeader() {
    return <PageHeader openLogo={{ newTab: true }} showBackButton={true} />
}
